import React from 'react';
import { Link } from 'react-router-dom';
import { GenericDetailPage } from '../../../components/generic';
import { useUser, User } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';
import { cn } from '../../../lib/utils';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<User>
      useData={useUser}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
        getDetailHeaderActions: (item, _mutate, colors) => (
          <div className="flex flex-wrap items-center gap-2">
            <Link
              to={`/admin/users/${item.id}/permissions`}
              className={cn(
                'inline-flex items-center rounded-lg px-3 py-1.5 text-xs font-medium',
                colors.surfaceHover,
                colors.text,
              )}
            >
              Permissions
            </Link>
            <Link
              to={`/admin/users/${item.id}/menu`}
              className={cn(
                'inline-flex items-center rounded-lg px-3 py-1.5 text-xs font-medium',
                colors.surfaceHover,
                colors.text,
              )}
            >
              Customize menu
            </Link>
          </div>
        ),
      }}
    />
  );
};

export default Detail;
